import React from 'react';
import logo from "../Assets/logo.svg";


const ThankyouPage = () => {
  return (
    <section class="container-fluid sec1">
      <div class="custom-container">
        <div class="col-xl-12 col-lg-12 col-md-12 col-12 text-center pt-5 pb-5">
          <img
            src={logo}
            alt="Parul University Logo"
            class="logo-img"
          />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-12">
          <h1 class="fw-bold text-danger">
            Thank You         </h1>
        </div>
      </div>
    </section>
  )
}

export default ThankyouPage